// extracted by mini-css-extract-plugin
export var pList = "jd";
export var aImage = "kd";
export var aDetail = "ld";
export var aTitle = "md";
export var aText = "nd";
export var animationMarquee = "od";